/**
 * Field type constants for form field rendering and management
 */

/**
 * Parent field types that render their child controls inline rather than as separate form fields.
 * Examples:
 * - Lookup/Picklist: render "Not Listed" togglebox inline
 * - TextWithLabel: renders N/A togglebox inline
 * - CustomBPField: renders N/A togglebox, Orthostatic checkbox, and secondary BP field inline
 */
export const PARENT_TYPES_WITH_INLINE_CONTROLS = [
  "Lookup",
  "Picklist",
  "TextWithLabel",
  "Date/Time",
  "Multi-Select Picklist",
  "CustomBPField",
] as const;

/**
 * Field types that are typically rendered inline within their parent components
 * rather than as standalone form fields.
 */
export const INLINE_FIELD_TYPES = ["Togglebox", "Checkbox", "Text"] as const;

/**
 * Field types that should never be rendered as standalone fields.
 * These are always managed internally by their parent components.
 */
export const NON_STANDALONE_FIELD_TYPES = ["SecondaryBPField"] as const;
